export default __webpack_public_path__ + "static/media/KAIROS-90.16399b02.jpg";